import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.overlay = document.getElementById("sidebar-overlay")
  }

  toggle() {
    const sidebar = document.getElementById("sidebar")
    sidebar.classList.toggle("open")
    this.overlay.classList.toggle("active")
  }

  close() {
    const sidebar = document.getElementById("sidebar")
    sidebar.classList.remove("open")
    this.overlay.classList.remove("active")
  }
}
